import { css } from 'styled-components';
export const rawLinkEffect = () => css `
  color: ${({ theme }) => theme.colors.link};
  font-weight: ${({ theme }) => theme.fontWeights[1]};
  text-decoration: underline;
  text-decoration-thickness: 2px;
`;
//# sourceMappingURL=rawLinkEffect.js.map